var map = {
	"./Day.svg": "1eb3",
	"./Debande.webp": "293f",
	"./Khalid.webp": "8c71",
	"./OM-green-certificate.png": "a8dd",
	"./TV-show.png": "210b",
	"./Yousef.webp": "822f",
	"./Yousuf.webp": "67cb",
	"./arrow-left.svg": "9191",
	"./arrow-right.svg": "6830",
	"./avatar-default.png": "7a5c",
	"./banner.webp": "b16c",
	"./banner1-mb.webp": "2c49",
	"./banner1.webp": "3d96",
	"./bg-fr-mb.webp": "1884",
	"./bg-frame-mb.webp": "cd7a",
	"./confetty.webp": "19bd",
	"./double.webp": "1519",
	"./frame-768.png": "a8fe",
	"./frame-768.webp": "bb94",
	"./frame-992.png": "9640",
	"./frame-992.webp": "7f2f",
	"./frame-mb.png": "4d44",
	"./frame-mb.webp": "bbbe",
	"./frame.png": "919f",
	"./frame.webp": "bcb4",
	"./green-certificate-and-seed.webp": "5416",
	"./icon-more.png": "84c7",
	"./icon-win1.svg": "5b5e",
	"./icon-win2.svg": "a923",
	"./icon-win3.svg": "ed58",
	"./introduce.webp": "518d",
	"./left-arrow-line-symbol.png": "bbe2",
	"./match-3.webp": "4b21",
	"./match-4.webp": "01b7",
	"./match-5.webp": "c2df",
	"./match-6.webp": "6117",
	"./match-7.webp": "26be",
	"./number1.webp": "ee15",
	"./number2.webp": "43ec",
	"./number3.webp": "1e93",
	"./om.png": "6e63",
	"./om.webp": "9d5d",
	"./people-frame-mb.webp": "c12b",
	"./people-frame.webp": "fc84",
	"./person-frame-mb.webp": "f462",
	"./person-frame.webp": "6070",
	"./prize-frame.webp": "6c2e",
	"./rec.webp": "6b09",
	"./rectangle.webp": "e4c4",
	"./right-arrow-angle.png": "76b2",
	"./single.webp": "85ef",
	"./slide1-768.png": "4d51",
	"./slide1-992.png": "280a",
	"./slide1-mb.png": "be89",
	"./slide1.png": "402d",
	"./slide2-768.png": "cf03",
	"./slide2-992.png": "32b0",
	"./slide2-mb.png": "df3b",
	"./slide2.png": "d730",
	"./slide3-768.png": "0f9f",
	"./slide3-992.png": "f42b",
	"./slide3-mb.png": "5149",
	"./slide3.png": "7690",
	"./slide4-768.png": "4e15",
	"./slide4-992.png": "0ea5",
	"./slide4-mb.png": "8054",
	"./slide4.png": "4113",
	"./slide5-768.png": "1c8a",
	"./slide5-992.png": "9e93",
	"./slide5-mb.png": "5c13",
	"./slide5.png": "edb2",
	"./slide6-768.png": "bddf",
	"./slide6-992.png": "0e20",
	"./slide6-mb.png": "8aa9",
	"./slide6.png": "ca48",
	"./sub-frame.webp": "36dc",
	"./view-live.png": "26af",
	"./view-live.svg": "4bbf",
	"./view-live.webp": "aa8f",
	"./winner.webp": "bb2b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2912";